/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { ControlledForm, ConfirmationDialog } from 'components'
import Button from '@mui/material/Button'

type Filter = Record<string, any>
export type FilterDialogProps = {
  open?: boolean;
  filter: Filter;
  dialogTitle?: string;
  onFilterChange: (filter: Filter) => void;
  onClose: () => void;
  children?: React.ReactNode;
}

type State = {
  filter: Record<string, any>;
};

export class FilterDialog extends Component<FilterDialogProps, State> {
  static defaultProps = {
    dialogTitle: 'Filters'
  }

  constructor(props) {
    super(props)

    this.state = {
      filter: props.filter
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      this.setState({ filter: this.props.filter })
    }
  }

  get hasFiltersApplied() {
    return Object.values(this.props.filter).some(x => x && (!Array.isArray(x) || x.length !== 0))
  }

  handleChange = () => {
    this.props.onFilterChange(this.state.filter)
  }

  handleCloseFilters = () => {
    this.props.onClose()
  }

  handleFilterConfirm = () => {
    this.handleChange()
    this.handleCloseFilters()
  }

  handleFilterCancel = () => {
    this.setState({ filter: this.props.filter })
    this.handleCloseFilters()
  }

  handleFilterChanged = (filter) => {
    this.setState({ filter })
  }

  handleResetFilter = () => {
    this.setState({
      filter: Object.entries(this.state.filter).reduce((agg, [key, val]) => ({ ...agg, [key]: Array.isArray(val) ? [] : undefined }), {})
    })
  }

  render = () => {
    const { dialogTitle, children, open } = this.props
    const { filter } = this.state
    return (
      <ConfirmationDialog
        title={dialogTitle}
        open={open}
        onConfirm={this.handleFilterConfirm}
        onCancel={this.handleFilterCancel}
        confirmLabel={'Filter'}
        cancelLabel={'Cancel'}
      >
        <ControlledForm onChange={this.handleFilterChanged} data={filter}>
          <div css={styles.form}>
            {children}
          </div>
          <Button onClick={this.handleResetFilter}>Reset Filters</Button>
        </ControlledForm>
      </ConfirmationDialog>
    )
  }
}

const styles = {
  form: {
    paddingBottom: 20,
    '& h6': {
      marginTop: 20
    }
  }
}

export default FilterDialog
